import {
    styled,
    styledForMobile,
    SIDEBAR_SPACING,
    SIDEBAR_SPACING_MOBILE,
} from "@l2r-front/l2r-ui"

import { DocumentList } from "../DocumentList"

export const Container = styledForMobile("div")(({ isMobile, theme }) => ({
    flex: "1 1 auto",
    display: "flex",
    flexDirection: "column",
    minHeight: "100%",
    overflowY: "scroll",
    padding: isMobile ? theme.spacing(0, SIDEBAR_SPACING_MOBILE, 0, SIDEBAR_SPACING_MOBILE) : theme.spacing(5, SIDEBAR_SPACING, 0, SIDEBAR_SPACING),
}))

export const List = styled(DocumentList)(() => ({
    flex: "1 1 auto",
}))

export const PaginationContainer = styledForMobile("div", ["position"])(({ isMobile, position, theme }) => ({
    backgroundColor: theme.palette["common/white_states"].main,
    display: "flex",
    justifyContent: "center",
    position: position,
    bottom: 0,
    paddingTop: theme.spacing(5),
    paddingBottom: isMobile ? theme.spacing(SIDEBAR_SPACING_MOBILE) : theme.spacing(5),
    margin: isMobile ? theme.spacing(0, -SIDEBAR_SPACING_MOBILE, 0, -SIDEBAR_SPACING_MOBILE) : theme.spacing(0, -SIDEBAR_SPACING, 0, -SIDEBAR_SPACING),
}))